import { useState } from 'react';
import apiClient from '../../utils/apiClient';
import styles from './RegisterForm.module.css';

export default function RegisterForm({ onRegister }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    companyName: '',
    isOwner: true
  });
  const [domainWarning, setDomainWarning] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleEmailBlur = async (e) => {
    const email = e.target.value;
    if (!email.includes('@')) return;
    try {
      const { data } = await apiClient.get(`/api/auth/check-domain?email=${encodeURIComponent(email)}`);
      setDomainWarning(data.exists ? data.company_name : null);
    } catch {
      // non-critical, silently ignore
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await onRegister(form);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className={styles.logoContainer}>
        <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
        <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
        <p className={styles.subtitle}>Create your account</p>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          className={styles.input}
          name="name"
          placeholder="Full Name"
          onChange={handleChange}
          required
        />
        <input
          className={styles.input}
          name="email"
          type="email"
          placeholder="Email"
          onChange={handleChange}
          onBlur={handleEmailBlur}
          required
        />

        {domainWarning && (
          <div className={styles.domainWarning}>
            <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
            </svg>
            <div>
              <strong>Your company may already be on Nodel</strong>
              It looks like <strong>{domainWarning}</strong> is already registered. If you're part of that team, ask your admin to invite you instead of creating a new account.
            </div>
          </div>
        )}

        <input
          className={styles.input}
          name="password"
          type="password"
          placeholder="Password"
          onChange={handleChange}
          required
        />
        <input
          className={styles.input}
          name="companyName"
          placeholder="Company Name"
          onChange={handleChange}
          required
        />
        <button className={styles.button} type="submit" disabled={submitting}>
          {submitting ? 'Creating account…' : 'Register'}
        </button>
      </form>
    </div>
  );
}
